let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i2Mlg")).then(() => parcelRequire('3f70t'));